import React from "react";
import {
  setPage,
  setSelectedPayment,
  VacuumStore,
} from "../../../../stores/VacuumStore/VacuumStore";
import TotemSkeleton from "../../components/TotemSkeleton/TotemSkeleton";
import TotemButton from "../../components/TotemButton/TotemButton";
import { VacOptionsContainer, TotalValue } from "./VacuumPaymentStyles";
import TotemOption from "../../components/TotemOption/TotemOption";
import { useUnit } from "effector-react";
import { PAGES } from "../../../../stores/VacuumStore/VacumStore.types";
import { paymentOptions } from "../../../../stores/VacuumStore/VacumStore.consts";
import { toast } from "react-toastify";
import { PaymentOption } from "../../../../types/vacuum.types";

const VacuumPayment: React.FC = () => {
  const { selectedPayment, finalPrice } = useUnit(VacuumStore);

  const handleGoBack = () => {
    setPage(PAGES.TIME_CHOICE);
  };
  const handleConfirmPayment = () => {
    if (!selectedPayment?.type) {
      toast.error("Selecione uma forma de pagamento!");
      return false;
    }
    setPage(PAGES.VACUUM_PAYMENT_LOADING);
  };

  const renderOptions = () =>
    paymentOptions.map((option: PaymentOption) => {
      const isselected = selectedPayment?.type === option.type;

      return (
        <TotemOption
          key={option.type}
          title={option.title}
          isselected={isselected}
          execSelection={() => setSelectedPayment(option)}
        />
      );
    });

  const Buttons = (
    <>
      <TotemButton negative onClick={() => handleGoBack()} text="Voltar" />
      <TotemButton
        onClick={() => handleConfirmPayment()}
        disabled={!selectedPayment?.type}
        text="Realizar Pagamento"
      />
    </>
  );

  const renderPrice = () => (
    <TotalValue>
      <p>Total</p>

      <p>R$ {finalPrice.toFixed(2)}</p>
    </TotalValue>
  );

  return (
    <TotemSkeleton title="Forma de pagamento" buttons={Buttons}>
      <VacOptionsContainer>{renderOptions()}</VacOptionsContainer>
      {renderPrice()}
    </TotemSkeleton>
  );
};

export default VacuumPayment;
